import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { DisplayText, useResponsive } from '@garnish/core';

import { FlexLandingPageContent } from './FlexLandingPageContent';

export const FlexLandingPageBanner = (props: FlexLandingPageBannerProps) => {
  const { banner } = props;
  const { match } = useResponsive();

  return (
    <View style={styles.background}>
      <FlexLandingPageContent
        style={match([styles.containerXS, styles.containerSM, styles.containerLG])}
      >
        <DisplayText sizeMatch={['32', '40']} style={styles.banner}>
          {banner}
        </DisplayText>

        <View style={styles.divider} />
      </FlexLandingPageContent>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  background: {
    width: '100%',
    minHeight: 368,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.KALE,
  },
  containerXS: {
    paddingHorizontal: theme.spacing['6'],
    paddingTop: theme.spacing['16'],
    paddingBottom: theme.spacing['11'],
    gap: theme.spacing['5'],
  },
  containerSM: {
    paddingHorizontal: theme.spacing['24'],
    paddingTop: theme.spacing['30'],
    paddingBottom: theme.spacing['18'],
    gap: theme.spacing['6'],
  },
  containerLG: {
    paddingHorizontal: theme.spacing['40'],
    paddingTop: theme.spacing['30'],
    paddingBottom: theme.spacing['24'],
    gap: theme.spacing['6'],
  },
  banner: {
    color: theme.colors.WHITE,
    textAlign: 'center',
  },
  divider: {
    alignSelf: 'center',
    width: 120,
    height: 4,
    borderRadius: 2,
    backgroundColor: theme.colors.CUCUMBER,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type FlexLandingPageBannerProps = {
  banner: string;
};
